import * as React from 'react';
import * as _ from 'lodash';
import { Button, List, Checkbox } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

import { FormItem } from '../../../../../components/Form';
import InsuranceLimitRow from './components/InsuranceLimitRow';
import InsuranceLimitDetail from './components/InsuranceLimitDetail';

export interface IDeliveryMethodInsuranceLimitsProps {
  deliveryMethod: GQL.IDeliveryMethod;
  currency: GQL.ICurrency;
  onChange: Function;
}

export interface IDeliveryMethodInsuranceLimitsState {
  valueIndex?: any;
}

export default class CountryStates extends React.Component<IDeliveryMethodInsuranceLimitsProps, IDeliveryMethodInsuranceLimitsState> {

  public constructor(props: IDeliveryMethodInsuranceLimitsProps) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  public render() {
    const { deliveryMethod, currency } = this.props;

    return (
      <div>
        <FormItem>
          <Checkbox
            name={'insurance'}
            checked={deliveryMethod.insurance || false}
            onChange={(e: any) => this.props.onChange({ target: { name: 'insurance', checked: e.target.checked } })}
          >
            Insurance
          </Checkbox>
        </FormItem>
        {deliveryMethod.insurance === true &&
          <FormItem label={'Insurance limits'}>
            <List
              size={'small'}
              bordered={true}
              dataSource={deliveryMethod.insuranceLimits || []}
              renderItem={(limit: any, index: number) => {
                return (
                  <List.Item
                    actions={[
                      <Button
                        key={1}
                        danger={true}
                        size={'small'}
                        icon={<DeleteOutlined />}
                        onClick={() => {
                          let states = [...deliveryMethod.insuranceLimits || []];
                          states.splice(index, 1);
                          this.onChange('insuranceLimits', states);
                        }}
                      />
                    ]}
                    key={index}
                    style={{ paddingRight: '8px' }}
                  >
                    <InsuranceLimitRow
                      limit={limit}
                      currency={currency}
                      onClick={() => this.setState({ valueIndex: index }) }
                    />
                  </List.Item>
                );
              }}
            />
            <Button 
              onClick={() => this.setState({ valueIndex: -1 })} 
              style={{ float: 'right', marginTop: 10 }}
            >
              New limit
            </Button>
          </FormItem>}

        {this.state &&
          this.state.valueIndex != undefined && (
            <InsuranceLimitDetail
              limit={this.getValueForDetail() || {} as GQL.IDeliveryMethodInsuranceLimit}
              currency={currency}
              onSave={(limit: GQL.IDeliveryMethodInsuranceLimit) => this.onSaveInsuranceLimit(limit)}
              onCancel={() => this.setState({ valueIndex: undefined })}
            />
          )}
      </div>
    );
  }

  private getValueForDetail() {
    if (this.state.valueIndex !== undefined) {
      if (this.props.deliveryMethod && this.props.deliveryMethod.insuranceLimits) {
        return this.props.deliveryMethod.insuranceLimits[this.state.valueIndex];
      }
    }

    return {} as GQL.IDeliveryMethodInsuranceLimit;
  }

  private onSaveInsuranceLimit(limit: GQL.IDeliveryMethodInsuranceLimit) {
    const deliveryMethod = {...this.props.deliveryMethod};

    // ošetření
    if (!deliveryMethod.insuranceLimits) {
      deliveryMethod.insuranceLimits = [];
    }
    // editace
    if (this.state.valueIndex >= 0) {
      deliveryMethod.insuranceLimits[this.state.valueIndex] = limit;
    }
    // nový stát
    if (this.state.valueIndex === -1) {
      deliveryMethod.insuranceLimits.push(limit);
    }

    // setřídění podle názvu
    const insuranceLimits = deliveryMethod.insuranceLimits.sort((a: GQL.IDeliveryMethodInsuranceLimit, b: GQL.IDeliveryMethodInsuranceLimit) => {
      return (a.fromPriceOrder || 0) < (b.fromPriceOrder || 0) ? -1 : 0;
    });

    this.props.onChange({
      target: {
        name: 'insuranceLimits',
        value: insuranceLimits
      }
    });

    this.setState({
      valueIndex: undefined,
    });
  }

  private onChange(key: string, val: any) {
    this.props.onChange({
      target: {
        name: key,
        value: val
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/scenes/DeliveryMethods/DeliveryMethodDetail/components/Insurance/Insurance.tsx